import type React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface PartnerMetadataEditorProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | undefined;
}

/**
 * Raw JSON editor for the partner `metadata` column. This is intentionally a
 * plain textarea with parse-only validation — a structured editor will replace
 * it once the partner-metadata schema is defined. Empty input submits as null.
 */
export const PartnerMetadataEditor: React.FC<PartnerMetadataEditorProps> = ({
  id,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>Metadata</Label>
      <p className="text-xs text-muted-foreground">
        Raw JSON object. Leave empty to store nothing. A structured editor will replace this once
        the partner-metadata schema is defined.
      </p>
      <Textarea
        id={id}
        rows={6}
        className="font-mono text-xs"
        placeholder={'{\n  "key": "value"\n}'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={!!error}
        spellCheck={false}
      />
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
